import { useMemo } from 'react';

import { AuthService } from 'shared/lib/keycloak';
import { useGetUserProgramsQuery } from 'shared/api/retail';
import { collectDigitalExperienceAssets } from 'shared/lib/utils';

export const useDigitalExperienceAssetsBks = (): string[] | null => {
  const userBk = AuthService.getUserBk();

  const { data: userPrograms, isLoading: isUserProgramsLoading } =
    useGetUserProgramsQuery(userBk);

  return useMemo(() => {
    if (isUserProgramsLoading) return null;

    if (!userPrograms) return [];

    return collectDigitalExperienceAssets(userPrograms);
  }, [isUserProgramsLoading, userPrograms]);
};
